import { useCallback} from 'react';
import { useApi } from "./api"
// import { useShared } from "./shared"
import { LoginDTO, RegisterDTO, UploadDocumentDTO, CheckAccountDTO, Profile } from "../models"
import { useContextState } from '../context/Context';
import Cookies from 'js-cookie';



export const useAuth = () => {
    const { accountCTX } = useContextState();
    const { setSignedIn, profile, setProfile, resetAccountContext } = accountCTX
    const { $post, $patch } = useApi()
    // const { setTokens } = useShared()

    // Helper function for setting profile and signed-in state to reduce repetition
    const handleSuccessfulAuth = useCallback((data: any) => {
        if (!data) return;
        // console.log('data: ', data)
        // Destructure only the fields that are part of the Profile model
        const { email, userType, username, firstName, lastName, phone, birth, gender, status, profilePicture, id, userId, bonusTotal, summary, funFact, link, qrCode, notification } = data;
        if (userType === 'support' || userType === 'admin'){
            const newProfile: Profile = { email, username, firstName, lastName, phone, birth, gender, status, profilePicture, id, userId, bonusTotal, summary, funFact, link, qrCode, notification };
            
            setProfile(newProfile);
            setSignedIn(true);
        }
    }, [setProfile, setSignedIn]);

    const checkAccount = async (credentials: CheckAccountDTO) => {
        const data = await $post('account/action/check_if_account_exists/', credentials, false)
        return data
    }

    const loginCall = async (credentials: LoginDTO) => {
        const data = await $post('account/signin/', credentials, false);
        console.log('data: ', data)
        if (data?.res === 'success' && (data?.status === 'active') && (data?.userType === 'support' || data?.userType === 'admin')) {
            handleSuccessfulAuth(data);
            return data?.status
        }
        return false
    }

    const logoutCall = useCallback(async () => {
        setSignedIn(false);
        resetAccountContext();
        setProfile({} as Profile); 
        const data = await $post('account/signout/', { refresh: Cookies.get('refreshToken') }, false);
        Cookies.remove('token');
        Cookies.remove('refreshToken');
        return data;
    }, [$post, setSignedIn, setProfile]);

    

    return { checkAccount,  loginCall, logoutCall }
}
